import React, { ReactNode } from 'react';
import Collapse from '@/components/common/libraries/common/Collapse';
import Filter from '@/components/common/libraries/common/Filter';

interface FilterLike {
  label: ReactNode;
  value: string | number;
  checked?: boolean;
}

interface Props<F extends FilterLike> {
  filterClassName?: string;
  filters: F[];
  onChange: (value: string | number, checked: boolean) => void;
  outerClassName?: string;
  renderLabel?: (filter: F) => ReactNode;
  title: ReactNode;
}

// AIDEV-NOTE: Shared flat-list filter section for library FilterBars.
// Renders an outer Collapse with the section title and a list of
// Filter rows. Use `renderLabel` to decorate each row's label (e.g.
// AssessmentLibrary's Source filter renders a SourceIcon next to the
// label).
const FlatFilterSection = <F extends FilterLike>({
  filterClassName,
  filters,
  onChange,
  outerClassName,
  renderLabel,
  title,
}: Props<F>) => (
  <div className={outerClassName}>
    <Collapse triggerElement={<>{title}</>}>
      {filters.map(filter => (
        <Filter
          key={filter.value}
          checked={filter.checked ?? false}
          className={filterClassName}
          label={renderLabel ? renderLabel(filter) : filter.label}
          value={filter.value}
          onChange={onChange}
        />
      ))}
    </Collapse>
  </div>
);

export default FlatFilterSection;
